import { Box, Select } from '@mantine/core'
import { useForm } from '@mantine/form'
import {
  selectCurrentOrganization,
  selectOrganizations,
} from '@v2/domains/user/selectors/user.selectors'
import React from 'react'

import { useAppSelector } from 'src/v2/store/hooks'

import styles from './OrganizationSelector.module.scss'

interface OrganizationSelectorProps {
  onChange: (organizationId: string, membershipId: string) => void
  disabled?: boolean
}

export const OrganizationSelector: React.FC<OrganizationSelectorProps> = ({
  onChange,
  disabled = false,
}) => {
  const currentOrganization = useAppSelector(selectCurrentOrganization)
  const organizationsByUser = useAppSelector(selectOrganizations)

  const currentOrganizationId = currentOrganization.id

  const form = useForm({
    initialValues: {
      organizationId: currentOrganizationId || '',
    },
  })

  const handleChange = (value: string | null) => {
    if (value) {
      const organization = organizationsByUser.find((org) => org.id === value)

      if (organization) {
        const organizationId = organization.id!
        const membershipId = organization.memberships?.at(0)?.id ?? ''
        onChange(organizationId, membershipId)
        form.setFieldValue('organizationId', value)
      }
    }
  }

  const data = organizationsByUser.map((org) => ({
    value: org.id,
    label: org.name,
  }))

  return (
    <Box className={styles.container}>
      <Select
        label="Organization"
        placeholder="Select an organization"
        data={data}
        value={form.values.organizationId}
        onChange={handleChange}
        withAsterisk
        disabled={disabled}
        error={form.errors.organizationId}
        className={styles.selector}
        size="md"
      />
    </Box>
  )
}
